import React, { useState, useRef, useEffect } from 'react';

const ProfileImage = ({ employeeId, className = '' }) => {
  const [src, setSrc] = useState('');
  const fallbackIndex = useRef(0);
  const fallbackList = [`${employeeId}.png`, `${employeeId}.jpeg`];

  useEffect(() => {
    // Reset state when employeeId changes
    setSrc(`https://people.imagnumhealthcare.com/storage/employee_profile/${employeeId}.jpg`);
    fallbackIndex.current = 0;
  }, [employeeId]);

  const handleError = () => {
    if (fallbackIndex.current < fallbackList.length) {
      setSrc(
        `https://people.imagnumhealthcare.com/storage/employee_profile/${fallbackList[fallbackIndex.current++]}`
      );
    } else {
      setSrc('/assets/images/profile.png');
    }
  };

  return (
    <img
      src={src}
      onError={handleError}
      alt="Profile"
      loading="lazy"
      className={className}
    />
  );
};

export default ProfileImage;
